module.exports = __webpack_public_path__ + "img/5.985ce331.jpg";